export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11788.64e2e298.jpg";